module.exports = __webpack_public_path__ + "static/media/SF-Pro-Display-Black.f180bcab.otf";